import { useNavigate } from 'react-router-dom'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {}

const EmptySpace = ({}: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <Box
      borderRadius={{ all: 'abs008' }}
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      height="s400"
      flexGrow
      alignItems="center"
      justifyContent="center"
      gap="s16"
    >
      <Icon.Large icon="location-pin-remove" color="grey600" />
      <Box alignItems="center" justifyContent="center" gap="s4">
        <Text.Normal weight="bold">{i18n.t('space_control.overview.no_spaces_found')}</Text.Normal>
        <Text.Normal>{i18n.t('space_control.overview.create_spaces')}</Text.Normal>
      </Box>
      <Button type="secondary" onClick={() => navigate(navigation.settings.locations.fullPath())}>
        {i18n.t('space_control.overview.go_to_settings')}
      </Button>
    </Box>
  )
}

export default observer(EmptySpace)
